import { defineMessages } from 'react-intl';

const messages = defineMessages({
  weight: {
    description: 'bulkUpdateActions.weight',
    defaultMessage: 'Weight',
    id: 'IgJzJr',
  },
  adjustWeight: {
    description: 'bulkUpdateActions.adjustWeight',
    defaultMessage: 'Weight',
    id: 'eBcYPr',
  },
  addNote: {
    description: 'bulkUpdateActions.addNote',
    defaultMessage: 'Add Note',
    id: 'FBUXSW',
  },
  addTaxIdentifiers: {
    description: 'bulkUpdateActions.addTaxIdentifiers',
    defaultMessage: 'Tax Identifiers',
    id: 'LYMXmI',
  },
  applyShippingPreset: {
    description: 'bulkUpdateActions.applyShippingPreset',
    defaultMessage: 'Apply Shipping Preset',
    id: '32ebFD',
  },
  assignTo: {
    description: 'bulkUpdateActions.assignTo',
    defaultMessage: 'Assign To',
    id: '4Gu8Jw',
  },
  confirmation: {
    description: 'bulkUpdateActions.confirmation',
    defaultMessage: 'Confirmation',
    id: '5SQ1Ma',
  },
  customFieldOne: {
    description: 'bulkUpdateActions.customFieldOne',
    defaultMessage: 'Custom Field 1',
    id: 'O7PYPx',
  },
  customFieldTwo: {
    description: 'bulkUpdateActions.customFieldTwo',
    defaultMessage: 'Custom Field 2',
    id: '6GrJ6B',
  },
  customFieldThree: {
    description: 'bulkUpdateActions.customFieldThree',
    defaultMessage: 'Custom Field 3',
    id: 'U6gsqL',
  },
  customsDeclarations: {
    description: 'bulkUpdateActions.customsDeclarations',
    defaultMessage: 'Customs Declarations',
    id: 'Ho8+lc',
  },
  doNotNotifyMarketplace: {
    description: 'bulkUpdateActions.doNotNotifyMarketplace',
    defaultMessage: 'Do Not Notify Marketplace',
    id: 'imcZGq',
  },
  dutiesAndTaxes: {
    description: 'bulkUpdateActions.dutiesAndTaxes',
    defaultMessage: 'Prepay Duties and Taxes',
    id: 'IpIr3b',
  },
  emailTemplate: {
    description: 'bulkUpdateActions.emailTemplate',
    defaultMessage: 'Email Template',
    id: 'GNSELx',
  },
  insurance: {
    description: 'bulkUpdateActions.insurance',
    defaultMessage: 'Insurance',
    id: '32dwm8',
  },
  otherShippingOptions: {
    description: 'bulkUpdateActions.otherShippingOptions',
    defaultMessage: 'Other Shipping Options',
    id: 'a2pBfy',
  },
  packageBulkAction: {
    description: 'bulkUpdateActions.packageBulkAction',
    defaultMessage: 'Package',
    id: '/NMmTc',
  },
  packingSlipTemplate: {
    description: 'bulkUpdateActions.packingSlipTemplate',
    defaultMessage: 'Packing Slip Template',
    id: 'et+r/D',
  },
  service: {
    description: 'bulkUpdateActions.service',
    defaultMessage: 'Service',
    id: 'pXVKgC',
  },
  shipByDate: {
    description: 'bulkUpdateActions.shipByDate',
    defaultMessage: 'Ship by Date',
    id: 'MIJ3NG',
  },
  shipFrom: {
    description: 'bulkUpdateActions.shipFrom',
    defaultMessage: 'Ship From',
    id: '/cSh0n',
  },
  shippingAccount: {
    description: 'bulkUpdateActions.shippingAccount',
    defaultMessage: 'Shipping Account',
    id: '/zSi7H',
  },
  size: {
    description: 'bulkUpdateActions.size',
    defaultMessage: 'Size',
    id: 'XTpv+1',
  },
});

export const BulkActions = Object.freeze({
  addNote: {
    name: 'addNote',
    message: messages.addNote,
  },
  addTaxIdentifiers: {
    name: 'addTaxIdentifiers',
    message: messages.addTaxIdentifiers,
  },
  applyShippingPreset: {
    name: 'applyShippingPreset',
    message: messages.applyShippingPreset,
  },
  assignTo: {
    name: 'assignTo',
    message: messages.assignTo,
  },
  confirmation: {
    name: 'confirmation',
    message: messages.confirmation,
  },
  customFieldOne: {
    name: 'customFieldOne',
    message: messages.customFieldOne,
  },
  customFieldTwo: {
    name: 'customFieldTwo',
    message: messages.customFieldTwo,
  },
  customFieldThree: {
    name: 'customFieldThree',
    message: messages.customFieldThree,
  },
  customsDeclarations: {
    name: 'customsDeclarations',
    message: messages.customsDeclarations,
  },
  doNotNotifyMarketplace: {
    name: 'doNotNotifyMarketplace',
    message: messages.doNotNotifyMarketplace,
  },
  emailTemplate: {
    name: 'emailTemplate',
    message: messages.emailTemplate,
  },
  insurance: {
    name: 'insurance',
    message: messages.insurance,
  },
  otherShippingOptions: {
    name: 'otherShippingOptions',
    message: messages.otherShippingOptions,
  },
  packageBulkAction: {
    name: 'packageBulkAction',
    message: messages.packageBulkAction,
  },
  packingSlipTemplate: {
    name: 'packingSlipTemplate',
    message: messages.packingSlipTemplate,
  },
  service: {
    name: 'service',
    message: messages.service,
  },
  shipByDate: {
    name: 'shipByDate',
    message: messages.shipByDate,
  },
  shipFrom: {
    name: 'shipFrom',
    message: messages.shipFrom,
  },
  shippingAccount: {
    name: 'shippingAccount',
    message: messages.shippingAccount,
  },
  size: {
    name: 'size',
    message: messages.size,
  },
  weight: {
    name: 'weight',
    message: messages.weight,
  },
  adjustWeight: {
    name: 'adjustWeight',
    message: messages.adjustWeight,
  },
  dutiesAndTaxes: {
    name: 'dutiesAndTaxes',
    message: messages.dutiesAndTaxes,
  },
});
